import { useLayoutEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Hero from "../../components/Hero";
import Usecase from "../../components/Mobile/Usecase";
import Usecases from "../../components/Usecases";
import { TitleComponent } from "../../TitleComponent";

const UseCase = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <TitleComponent
        title="Use Cases"
        description="Create royalty-free, background music with the power of AI. Recommended for videos, podcasts & games. Try now!"
      />
      {/* header */}
      <Header />
      <section>
        <Hero
          heading="Use Cases"
          tagline="Beatoven.ai is great for a variety of use cases – From Agencies  to Web3 and the Metaverse."
          Style="max-w-4xl font-poppins font-normal text-3xl leading-normal text-center text-white opacity-80 mobile:leading-7 mobile:px-5 mobile:text-xl sm:px-5 sm:text-2xl"
        />
      </section>
      {/* use case */}
      <section className="max-w-6xl mx-auto py-20">
        <div className="relative">
          <div className="absolute w-56 h-56 left-0 bg-yellow-nyellow opacity-50 blur-3xl"></div>
          <Usecases />
          <div className="absolute w-56 h-56 right-20 bottom-10 bg-blue-nblue opacity-30 blur-3xl"></div>
        </div>
        <div className="hidden mobile:block mobile:px-5">
          <Usecase />
        </div>
      </section>
      {/* footer */}
      <section className="max-w-7xl mx-auto pt-5">
        <Footer />
      </section>
    </>
  );
};

export default UseCase;
